export const publicMessages = {
  kk: {
    public: {
      common: {
        blog: 'Блог',
        login: 'Кіру',
        start: 'Бастау',
        startFree: 'Тегін бастау',
        read: 'Оқу',
        allArticles: 'Барлық мақалалар',
        backHome: 'Басты бетке',
        minutes: 'мин оқу',
        footer: '© {year} Sauda · шағын бизнеске арналған касса мен есеп',
      },
      landing: {
        navModes: 'Режимдер',
        openCash: 'Кассаны ашу',
        chip: 'Дүкенге арналған онлайн-касса',
        heroTitle: 'Сатыңыз, қойманы жүргізіңіз және пайданы бір терезеден көріңіз',
        heroText: 'Sauda — шағын бизнеске арналған қарапайым касса: бірнеше батырмамен сату, қалдықтарды бақылау, жеңілдіктер, қарыздар, бірнеше кассир және түсінікті талдау. Қоймадағы тауарлармен жұмыс істеңіз немесе қалдықсыз жылдам сатуды қосыңыз — режимді кез келген уақытта ауыстыруға болады.',
        register: 'Тіркелу',
        hasAccount: 'Менде аккаунт бар',
        browser: 'Браузерде жұмыс істейді',
        devices: 'Телефон, планшет, компьютер',
        fiveMinutes: '5 минутта бастау',
        receipt: 'Чек 1',
        items: '3 тауар',
        milk: 'Сүт 1 л',
        cheese: 'Гауда ірімшігі',
        bread: 'Нан',
        perUnit: '₸/дана',
        perKg: '₸/кг',
        due: 'Төлеуге',
        pay: 'Төлеу',
        revenueToday: 'Бүгінгі түсім',
        vsYesterday: 'Кешегіден +12%',
        stockControl: 'Қойма бақылауда',
        stockAuto: 'қалдықтар автоматты жазылады',
        featuresTitle: 'Дүкенге керек нәрсенің бәрі',
        featuresSubtitle: 'Күрделі баптаусыз — тіркеліп, сата бересіз',
        features: {
          cash: { title: 'Жылдам касса', text: 'Бірнеше чекті қатар ашу, тауарды іздеу, картамен, қолма-қол немесе аралас төлем' },
          stock: { title: 'Қойма және қалдықтар', text: 'Қалдықтар сату кезінде автоматты жазылады. «Минусқа» сату мүмкін емес' },
          discounts: { title: 'Жеңілдіктер', text: 'Сомамен не пайызбен жеңілдік — кассадағы баға бірден қайта есептеледі' },
          cashiers: { title: 'Бірнеше кассир', text: 'Әр кассирге жеке кіру және икемді құқықтар. Кімнің қанша сатқанын көресіз' },
          analytics: { title: 'Талдау', text: 'Түсім, пайда, тауарлардың топ-10-ы, қызу сағаттар және азайған қалдықтар — бір экранда' },
          debts: { title: 'Қарыздар', text: 'Аты, телефоны және қайтару күнімен қарызға сату. Ештеңе жоғалмайды' },
          weighted: { title: 'Салмақты тауарлар', text: 'Электронды таразыны қосу: салмақ кассаға бір батырмамен түседі' },
          devices: { title: 'Кез келген құрылғы', text: 'Телефон, планшет немесе компьютер — интерфейс экранға бейімделеді' },
        },
        modesTitle: 'Кассаның екі режимі',
        modesSubtitle: 'Қалай сататыныңызды таңдаңыз — шешімді кез келген уақытта админ панелінде өзгертіңіз',
        withStock: 'Қоймамен',
        productMode: 'Тауарлар бойынша',
        productModeText: 'Қалдықтарды жүргізетін дүкенге арналған толыққанды касса',
        productPoints: ['Тауарды, санын немесе салмағын таңдау', 'Қалдықтар автоматты жазылады', 'Сомамен немесе пайызбен жеңілдік', 'Әр тауар бойынша талдау және сату топтары'],
        withoutStock: 'Қоймасыз',
        quickSale: 'Жылдам сату',
        quickSaleText: 'Тауар анықтамалығынсыз бастауға арналған',
        quickPoints: ['Тек чек сомасы мен төлем түрі', 'Қойма мен қалдықтар қолданылмайды', 'Бонустар мен қарыз әдеттегідей жұмыс істейді', 'Админ панелінде бір минутта қосылады'],
        modesNote: 'Тауарларды бірден енгізгіңіз келмей ме — жылдам сатудан бастаңыз, қойманы кейін қосасыз',
        audienceTitle: 'Sauda кімге арналған',
        audienceSubtitle: 'Жылдамдық пен қарапайымдылық маңызды шағын сауда нүктелеріне',
        audience: ['Мини-маркет', 'Кафе', 'Фастфуд', 'Үй жанындағы дүкен'],
        stepsTitle: 'Қалай бастау керек',
        stepsSubtitle: 'Алғашқы сатуға дейінгі үш қадам',
        steps: [
          { title: 'Тіркеліңіз', text: 'Дүкен атауын, e-mail және құпиясөзді енгізіңіз — аккаунт дайын' },
          { title: 'Админ панелінен режимді таңдаңыз', text: 'Қоймамен «Тауарлар бойынша» немесе қалдықсыз «Жылдам сату» — өзіңізге ыңғайлысын' },
          { title: 'Сатыңыз', text: 'Кассаны кез келген құрылғыдан ашып, чектерді өткізіңіз' },
        ],
        blogTitle: 'Пайдалы кеңестер',
        blogSubtitle: 'Касса, есеп және алғашқы қадамдар туралы қысқа мақалалар',
        pricing: {
          nav: 'Бағалар',
          title: 'Тарифтік жоспарлар',
          perks: '15 күн тегін  •  Қолдау 24/7  •  Тұрақты жаңартулар',
          audienceCafe: 'Кафе және мейрамханалар',
          audienceShop: 'Дүкендер',
          yearly: 'Жылдық төлем',
          perMonth: '₸/ай',
          popular: 'Танымал',
          allFrom: 'Барлығы {plan}-тан, қосымша:',
          viewAll: 'Барлық мүмкіндіктерді қарау',
          cta: 'Таңдау',
          plans: {
            starter: {
              name: 'Starter',
              desc: 'Жылдам бастау: сату және негізгі есеп.',
              price: '8 640',
              features: [
                'Браузердегі касса — телефон, планшет, ПК',
                'Жылдам сату режимі (сома бойынша)',
                'Тауарлар мен санаттар',
                'Төлем түрлері (қолма-қол, карта, аралас)',
                'Сату тарихы және чектер',
                'Чатта қолдау',
              ],
            },
            mini: {
              name: 'Mini',
              desc: 'Қойма мен пайданы бақылайтын шағын нүктелерге.',
              price: '15 660',
              features: [
                'Тауарлар бойынша режим + автоматты есептен шығару',
                'Қойма: қалдық, толықтыру, тарих',
                'Өзіндік құн және пайда',
                'Жеңілдіктер (сома / %)',
                'Талдау: түсім, топ тауарлар',
                'Ценниктерді басып шығару',
              ],
            },
            business: {
              name: 'Business',
              desc: 'Толық дүкен: кассирлер, лояльность және салмақты тауарлар.',
              price: '21 060',
              features: [
                'Бірнеше кассир және құқықтар',
                'Модификаторлар',
                'Бонус бағдарламасы',
                'Қарызға сату',
                'Салмақты тауарлар + электронды таразы',
                'Толық талдау және маржа',
              ],
            },
            pro: {
              name: 'Pro',
              desc: 'Кеңейтілген есеп, басып шығару және басым қолдау.',
              price: '31 860',
              features: [
                'Чектерді термопринтерге басып шығару',
                'Қайтару және сату бақылауы',
                'Штрихкод және іздеу',
                'Бірнеше құрылғыдан бір мезгілде жұмыс',
                'Басым қолдау 24/7',
              ],
            },
          },
        },
        tryTitle: 'Sauda-ны бүгін байқап көріңіз',
        tryText: 'Тіркелуге бірнеше минут кетеді — бірден сата беруге болады',
      },
      blog: {
        title: 'Пайдалы кеңестер',
        subtitle: 'Кассаны, есепті және алғашқы сатуларды артық әуресіз жүргізу туралы қысқа мақалалар',
        ready: 'Sauda-ны байқап көруге дайынсыз ба?',
        tryText: 'Тіркелуге бірнеше минут кетеді — бірден сата беруге болады',
      },
      post: {
        notFound: 'Мақала табылмады',
        notFoundText: 'Мүмкін, ол жылжытылған немесе жойылған',
        toArticles: 'Барлық мақалаларға',
        tryTitle: 'Sauda-ны бүгін байқап көріңіз',
        tryText: 'Тіркелуге бірнеше минут кетеді — тауармен немесе қоймасыз жылдам сату арқылы бірден сата беруге болады',
      },
    },
  },
  ru: {
    public: {
      common: {
        blog: 'Блог',
        login: 'Войти',
        start: 'Начать',
        startFree: 'Начать бесплатно',
        read: 'Читать',
        allArticles: 'Все статьи',
        backHome: 'На главную',
        minutes: 'мин чтения',
        footer: '© {year} Sauda · касса и учёт для малого бизнеса',
      },
      landing: {
        navModes: 'Режимы',
        openCash: 'Открыть кассу',
        chip: 'Онлайн-касса для магазина',
        heroTitle: 'Продавайте, ведите склад и смотрите прибыль — в одном окне',
        heroText: 'Sauda — простая касса для небольшого бизнеса: продажи за пару кликов, остатки под контролем, скидки, долги, несколько кассиров и понятная аналитика. Работайте по товарам со складом или включите быструю продажу без остатков — режим переключается в любой момент.',
        register: 'Зарегистрироваться',
        hasAccount: 'У меня есть аккаунт',
        browser: 'Работает в браузере',
        devices: 'Телефон, планшет, ПК',
        fiveMinutes: 'Старт за 5 минут',
        receipt: 'Чек 1',
        items: '3 поз.',
        milk: 'Молоко 1л',
        cheese: 'Сыр Гауда',
        bread: 'Хлеб',
        perUnit: '₸/шт',
        perKg: '₸/кг',
        due: 'К оплате',
        pay: 'Оплатить',
        revenueToday: 'Выручка сегодня',
        vsYesterday: '+12% к вчера',
        stockControl: 'Склад под контролем',
        stockAuto: 'остатки списываются сами',
        featuresTitle: 'Всё, что нужно магазину',
        featuresSubtitle: 'Без сложных настроек — зарегистрировались и продаёте',
        features: {
          cash: { title: 'Быстрая касса', text: 'Несколько чеков параллельно, поиск товара, оплата картой, наличными или смешанно' },
          stock: { title: 'Склад и остатки', text: 'Остатки списываются при продаже автоматически. Продать «в минус» невозможно' },
          discounts: { title: 'Скидки', text: 'Скидка суммой или процентом — цена на кассе пересчитывается мгновенно' },
          cashiers: { title: 'Несколько кассиров', text: 'Свой вход для каждого кассира и гибкие права. Видно, кто сколько продал' },
          analytics: { title: 'Аналитика', text: 'Выручка, прибыль, топ-10 товаров, пиковые часы и низкие остатки — на одном экране' },
          debts: { title: 'Долги (қарыз)', text: 'Продажа в долг с именем, телефоном и датой возврата. Ничего не потеряется' },
          weighted: { title: 'Весовые товары', text: 'Подключение электронных весов: вес подтягивается на кассу одной кнопкой' },
          devices: { title: 'Любое устройство', text: 'Телефон, планшет или компьютер — интерфейс подстраивается под экран' },
        },
        modesTitle: 'Два режима кассы',
        modesSubtitle: 'Выбирайте, как продавать — и меняйте решение в любой момент в админке',
        withStock: 'Со складом',
        productMode: 'По товарам',
        productModeText: 'Полноценная касса для магазина с остатками',
        productPoints: ['Выбор товара, количество или вес', 'Остатки списываются автоматически', 'Скидки суммой или процентом', 'Аналитика и топ продаж по каждому товару'],
        withoutStock: 'Без склада',
        quickSale: 'Быстрая продажа',
        quickSaleText: 'Для старта без товарного справочника',
        quickPoints: ['Только сумма чека и тип оплаты', 'Склад и остатки не задействованы', 'Бонусы и қарыз работают как обычно', 'Включается за одну минуту в админке'],
        modesNote: 'Не хотите заводить товары сразу — начните с быстрой продажи, а склад подключите позже',
        audienceTitle: 'Для кого Sauda',
        audienceSubtitle: 'Небольшие точки продаж, где важна скорость и простота',
        audience: ['Мини-маркет', 'Кафе', 'Фастфуд', 'Магазин у дома'],
        stepsTitle: 'Как начать',
        stepsSubtitle: 'Три шага до первой продажи',
        steps: [
          { title: 'Зарегистрируйтесь', text: 'Укажите название магазина, e-mail и пароль — аккаунт готов' },
          { title: 'Выберите режим в админке', text: '«По товарам» со складом или «Быстрая продажа» без остатков — как удобнее' },
          { title: 'Продавайте', text: 'Открывайте кассу с любого устройства и пробивайте чеки' },
        ],
        blogTitle: 'Польза и советы',
        blogSubtitle: 'Короткие статьи о кассе, учёте и первых шагах без лишней головной боли',
        pricing: {
          nav: 'Цены',
          title: 'Тарифные планы',
          perks: '15 дней бесплатно  •  Поддержка 24/7  •  Регулярные обновления',
          audienceCafe: 'Кафе и рестораны',
          audienceShop: 'Магазины',
          yearly: 'Оплата за год',
          perMonth: '₸/мес.',
          popular: 'Популярный',
          allFrom: 'Все из {plan}, плюс:',
          viewAll: 'Посмотреть все функции',
          cta: 'Выбрать',
          plans: {
            starter: {
              name: 'Starter',
              desc: 'Быстрый старт: продажи и базовый учёт.',
              price: '8 640',
              features: [
                'Касса в браузере — телефон, планшет, ПК',
                'Режим быстрой продажи (по сумме)',
                'Товары и категории',
                'Типы оплаты (наличные, карта, смешанно)',
                'История продаж и чеки',
                'Поддержка в чате',
              ],
            },
            mini: {
              name: 'Mini',
              desc: 'Для небольших точек со складом и контролем прибыли.',
              price: '15 660',
              features: [
                'Режим «По товарам» + автосписание остатков',
                'Склад: остатки, пополнение, история',
                'Себестоимость и прибыль',
                'Скидки (сумма / %)',
                'Аналитика: выручка, топ товаров',
                'Печать ценников',
              ],
            },
            business: {
              name: 'Business',
              desc: 'Полный магазин: кассиры, лояльность и весовые товары.',
              price: '21 060',
              features: [
                'Несколько кассиров и права доступа',
                'Модификаторы',
                'Бонусная программа',
                'Продажа в долг (қарыз)',
                'Весовые товары + электронные весы',
                'Полная аналитика и маржа',
              ],
            },
            pro: {
              name: 'Pro',
              desc: 'Расширенный учёт, печать чеков и приоритетная поддержка.',
              price: '31 860',
              features: [
                'Печать чеков на термопринтер',
                'Возвраты и контроль продаж',
                'Штрихкод и быстрый поиск',
                'Работа с нескольких устройств одновременно',
                'Приоритетная поддержка 24/7',
              ],
            },
          },
        },
        tryTitle: 'Попробуйте Sauda уже сегодня',
        tryText: 'Регистрация занимает пару минут — сразу можно продавать',
      },
      blog: {
        title: 'Польза и советы',
        subtitle: 'Короткие статьи о том, как вести кассу, учёт и первые продажи без лишней головной боли',
        ready: 'Готовы попробовать Sauda?',
        tryText: 'Регистрация занимает пару минут — сразу можно продавать',
      },
      post: {
        notFound: 'Статья не найдена',
        notFoundText: 'Возможно, она была перемещена или удалена',
        toArticles: 'Ко всем статьям',
        tryTitle: 'Попробуйте Sauda уже сегодня',
        tryText: 'Регистрация занимает пару минут — сразу можно продавать: по товарам или быстрой продажей без склада',
      },
    },
  },
}
